import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = not logged in
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  async function login(identifier, password) {
    setError("");
    const { data } = await api.post("/auth/login", { identifier, password });
    if (data.token) localStorage.setItem("rwms_token", data.token);
    setUser(data.user);
    return data.user;
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("rwms_token");
    setUser(false);
  }

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, error, setError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
